import React, { useState, useEffect } from "react";
import ScrollToTopSvg from "../Icons/ScrollToTopSvg";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          data-te-ripple-init
          className="fixed bottom-24 z-30 right-8 "
        >
          <ScrollToTopSvg />
        </button>
      )}
    </div>
  );
}
